/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { object, number, string, array } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { Link } from "@quintype/components";

import CardImageType6 from "../../molecules/card-image-type-6";
import CustomHeadline from "../../molecules/custom-headline";
import CarouselSlider from "../../molecules/carousel-slider";

import { getSlug } from "../../utils";

import "./organism-4.m.css";
class Organism4 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  render() {
    const { collection, headerType = 6, headlineLimit, href, sections, text = "" } = this.props;
    const stories = collection.items.filter(item => item.type === "story");
    const firstTwoStories = stories.slice(0, 2);
    const slug = getSlug(collection, sections);

    const children = firstTwoStories.map(story => (
      <div key={story.id}>
        <CardImageType6 story={story.story} headlineLimit={headlineLimit} />
      </div>
    ));

    return (
      <div styleName="wrapper">
        {this.state.width >= 768 &&
          stories.length >= 1 && <CustomHeadline text={text} headerType={headerType} href={href} />}
        {this.state.width < 768 &&
          stories.length >= 2 && <CustomHeadline text={text} headerType={headerType} href={href} />}
        <div styleName="title-wrapper">
          {stories.length > 2 && (
            <Link styleName="read-more read-more-desktop" href={slug}>
              <span styleName="read-more-desktop-content">See More Stories</span>
            </Link>
          )}
        </div>
        {stories.length > 2 && (
          <Link styleName="read-more read-more-mobile" href={slug}>
            <span>See More Stories</span>
          </Link>
        )}
        {global.width >= 768 && <div styleName="stories-wrapper">{children}</div>}
        {global.width < 768 && stories.length > 1 && <CarouselSlider collection={collection} type="videos" />}
      </div>
    );
  }
}

Organism4.propTypes = {
  collection: object,
  headerType: number,
  headlineLimit: number,
  href: string,
  sections: array,
  text: string
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(Organism4);
